import hrHr from './hr-HR.json';

type LocalizationKeys = keyof typeof hrHr | any;

export const useLocalizer = (): LocalizationKeys => {
  return hrHr;
};
